import { ReactNode } from 'react'

export const NoListResult: React.FC<{ children: ReactNode }> = (props) => {
  return (
    <div className="w-full flex flex-col items-center justify-center h-80">{props.children}</div>
  )
}

export const NoListHeader: React.FC<{ children: ReactNode }> = (props) => {
  return (
    <h2 className="text-brandGrayForLightBg text-2xl uppercase tracking-widest font-bold">
      {props.children}
    </h2>
  )
}
